import { useAppSelector } from '@state/hooks'

/**
 * Canonical tooltip for any control disabled because the active company is
 * the read-only Sample Company. Centralized so copy stays consistent across
 * tabs (Strategy Workspace, Execution, Vigil, Agency Console, Review,
 * conversation sidebar). General rule: a user can view/interact with a
 * sample company, but cannot add / change / delete.
 */
export const SAMPLE_COMPANY_TOOLTIP =
  'This control is disabled for the Sample Company. Switch to your own company to add, change, or delete.'

/**
 * Returns true when the currently active company is the Sample Company.
 * Backend mutations are already blocked by `require_writable_company`; this
 * hook is the UI mirror so users see the gate in advance instead of clicking
 * through to a 4xx.
 */
export function useIsSampleCompany(): boolean {
  return useAppSelector((s) => {
    const activeId = s.companies.activeCompanyId
    if (!activeId) return false
    return !!s.companies.companies.find((c) => c.id === activeId)?.isSample
  })
}
